<template>
  <TicketTable
    v-if="!loading"
    :dev_id="dev_id"
    :filter_asc="filter_asc"
    :filter_type="filter_type"
    :tickets="tickets"
    :show_new_ticket="false"
    @change_filter="change_filter"
    @change_list="change_list"
    @clear_list="clear_list"
  />
</template>
<script>

import TicketTable from "@/views/Dashboard/General/Supports/TicketList/TicketTable/TicketTable.vue";

export default {
  name: 'device_tickets',
  components: {
    TicketTable
  },
  props: ['dev_id', 'dev_fid'],

  data () {
    return {
      filter_type: 'status',
      filter_asc: 'asc',
      searched_list: [],
      search: false,
      ticket_list: [],
      loading: true
    }
  },
  created(){
    this.get_device_tickets()
  },
  computed: {
    tickets () {
      let list = this.search ? this.searched_list : this.ticket_list
      list.length ? list.sort(this.compareNumbers): ''
      return list
    },
  },
  methods: {
    get_device_tickets(){
      const filter = {
        fid: this.dev_fid
      }
      this.$http.v1.getTicketList(filter, (response) => {
        this.ticket_list = response.data
        this.loading = false
      })
    },

    change_list(data){
      this.search = true
      this.searched_list = data
    },

    clear_list(){
      this.search = false
      this.searched_list = []
    },
  }
}

</script>
<style>

</style>
